import React from 'react'
import { TextField, InputAdornment } from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'

const Email = ({ handleOnChange, error, register, withIcon }) => {
	return (
		<TextField
			{...register('email', {
				pattern: {
					value:
						/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
					message: 'Invalid email address'
				},
				required: 'this field is required'
			})}
			error={!!error}
			helperText={error?.message}
			variant='outlined'
			fullWidth
			id='email'
			label='Email address *'
			name='email'
			autoComplete='email'
			InputProps={{
				endAdornment: withIcon ? (
					<InputAdornment position='start'>
						<EmailIcon />
					</InputAdornment>
				) : null
			}}
			onChange={handleOnChange}
		/>
	)
}

export default Email
